import { buildCamel } from './build_helper';

// For testing purposes
// Use this if specs require stubbing globalThis.location attributes
export function getWindowLocationHref() {
  return globalThis.location.href;
}

export function getWindowLocationSearch() {
  return globalThis.location.search;
}

export function getWindowLocationHostname() {
  return globalThis.location.hostname;
}

export function getWindowLocationPathname() {
  return globalThis.location.pathname;
}

export function getWindowLocationPort() {
  return globalThis.location.port;
}

export function getDocumentReferrer() {
  return document.referrer;
}

export function getDocumentTitle() {
  return document.title;
}

export function getClientUserAgent() {
  return globalThis.navigator.userAgent;
}

export function isPageVisible() {
  return document.visibilityState === 'visible';
}

const VENDOR_PREFIXES = ['', 'ms', 'webkit'];

export function pageVisibleEventName() {
  const visPrefix = VENDOR_PREFIXES.find(vendorPrefix => {
    const prop = buildCamel(vendorPrefix, 'hidden'); // hidden, msHidden, webkitHidden
    return (document as any)[prop] !== undefined; // document.hidden, document.msHidden, document.webkitHidden
  });
  return `${visPrefix}visibilitychange`;
}
